module.exports = __webpack_public_path__ + "static/media/rowCrop.f75ae6d6.jpg";